// @flow
import { Redirect } from "react-router-dom";
import { RouteProvider } from "views/components/Provider";
import { Spinner } from "views/mobile/components/common";
import { formatDatetime, minDiff } from "lib/date";
import { iOS } from "lib/isSafari";
import { pathOr } from "ramda";
import {
	selectReservation,
	selectReservationById,
} from "state/reservations/selectors";
import { useAuth } from "hooks/useAuth";
import { useCancelReservation } from "state/reservations/hooks";
import { useHistory } from "react-router-dom";
import { useLine } from "state/lines/hooks";
import { useOffice } from "state/offices/hooks";
import { useState } from "react";
import { useUpdateUserInfo } from "state/users/hooks";
import React, { useDispatch, useEffect, useGlobal } from "reactn";

const ReserveScreen = ({ match, children }) => {
	const history = useHistory();
	const [ModalState, setModalState] = useState("open");
	const getLines = useDispatch("requestLines");
	const getReservationById = useDispatch("getReservationById");
	const getReservationByIdV3 = useDispatch("getReservationByIdV3");
	const { isLoggedInTemporary } = useAuth();
	const officeSlug = match.params.office;
	const lineSlug = match.params.line;
	const reservationId = match.params.id;
	const [user] = useGlobal("user");
	const [myReservations] = useGlobal("myReservations");
	const [userId, setUserId] = useState("");
	const [openCancelModal, setOpenCancelModal] = useState(false);
	const [office, officeLoading] = useOffice(officeSlug);
	const [line, lineLoading] = useLine(lineSlug, officeSlug);
	const reservationRespald = selectReservationById(myReservations);
	const reservation =
		selectReservation(myReservations, reservationId) ||
		reservationRespald ||
		{};
	const isAllowRervationsV3 = pathOr(
		false,
		["options", "isAllowRervationsV3"],
		office
	);

	const whatsapp = pathOr(false, ["notifications", "whatsapp"], user);
	const token = pathOr(false, ["token"], user);
	const push = pathOr(false, ["notifications", "push"], user);
	const timezone = pathOr("America/Santiago", ["timezone"], office);
	const activeMeetButton =
		reservation &&
		reservation.from &&
		minDiff(reservation.from, -15, timezone);
	const never_show_popup_notifications = pathOr(
		false,
		["notifications", "never_show_popup_notifications"],
		user
	);

	const redirectUrl = pathOr(
		false,
		["meta", "redirect_after_reservation"],
		line
	);
	useEffect(() => {
		let timer;
		if (redirectUrl && redirectUrl.active) {
			const timeout = redirectUrl.delay * 1000;
			timer = setTimeout(() => {
				redirectUrl.newTab
					? window.open(redirectUrl.url, "_blank")
					: (window.location.href = redirectUrl.url);
			}, timeout);
		}
		return () => {
			clearTimeout(timer);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [redirectUrl]);

	useEffect(() => {
		if (reservationId?.length)
			isAllowRervationsV3
				? getReservationByIdV3(reservationId)
				: getReservationById(reservationId);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [preferences, setPreferences] = useState({
		whatsapp,
		push,
		never_show_popup_notifications,
	});
	const [update, loading, error, resolved] = useUpdateUserInfo();
	const [cancelReservation, cancelLoading] = useCancelReservation(
		reservationId,
		reservation.isV2,
		isLoggedInTemporary,
		officeSlug
	);
	const isVisibleNotificationModal = ModalState === "open";

	const setCloseModal = () => setModalState("closed");

	const goToMeet = (reservationId) => {
		window.open(`https://meet.zeroq.cl/${reservationId}`);
	};
	useEffect(() => {
		officeSlug && getLines({ officeSlug });
	}, [officeSlug]);

	useEffect(() => {
		if (preferences.push === true)
			update({ ...preferences, onlyPreferences: true });
		if (preferences.never_show_popup_notifications === true)
			update({ ...preferences, onlyPreferences: true });
	}, [preferences]);

	useEffect(() => {
		if (!iOS) {
			if (
				(window &&
					window.Notification &&
					window.Notification.permission === "default") ||
				(!preferences.push &&
					!preferences.never_show_popup_notifications) ||
				(preferences.push === false &&
					preferences.never_show_popup_notifications === false)
			) {
				setModalState("open");
				return;
			}
			if (
				window &&
				window.Notification &&
				window.Notification.permission === "granted" &&
				!preferences.push &&
				!preferences.never_show_popup_notifications
			) {
				setModalState("open");
				return;
			}
			if (
				window &&
				window.Notification &&
				window.Notification.permission === "granted" &&
				preferences.push === false &&
				preferences.never_show_popup_notifications === false
			) {
				setModalState("open");
				return;
			}
		}
	}, []);
	useEffect(() => {
		setUserId(JSON.stringify(user.user_id));
	}, [user]);

	/*
	if (!reservation && !myReservations.loading)
		return (<DelayedRedirect to="/tickets/reserves" delay={5e3}>
			<div>
				No existe registro de tu reserva. Serás redirigido a la página de reservas.
			</div>
		</DelayedRedirect>
		)
	*/

	if (reservation.deleted)
		return <Redirect to={`/offices/${officeSlug}/lines/${lineSlug}`} />;

	if (!office || !line || !reservation) return <Spinner full />;

	const reservationCofirmed = pathOr(false, ["confirmed"], reservation);

	return children({
		goToMeet,
		activeMeetButton,
		history,
		setOpenCancelModal,
		openCancelModal,
		line,
		reservation,
		user,
		isLoggedInTemporary,
		userId,
		never_show_popup_notifications,
		push,
		setPreferences,
		isVisibleNotificationModal,
		setCloseModal,
		setModalState,
		code: reservation.code,
		reservationCofirmed,
		office,
		name: line.name,
		wait: line.wait,
		waiting: line.waiting,
		onClick: cancelReservation,
		loading: officeLoading || lineLoading || myReservations.loading,
		datetime: formatDatetime(reservation.from, office.timezone),
		cancelLoading,
		token,
	});
};

// this is not being used but it's a cleaner implementation
/*
const ReserveScreen2 = ({ match, children }: RouteComponentProps) => {
	const officeSlug = match.params.office;
	const reservationId = match.params.id;
	const reservation = selectReservation();

	const [myReservations, loading, error] = useReservations(); //useReservation(officeSlug, lineSlug)
	const [cancelReservation, cancelLoading] = useCancelReservation(reservation.id, reservation.isV2);
	const [line, lineLoading, lineError] = useLine(lineSlug);
	const [office, officeLoading, officeError] = useLine(officeSlug);

	// Reserva no encontrada:
	if (!reservation && !lineLoading && !officeLoading)
		return (<DelayedRedirect to="/tickets/reserves">
			<div>
				No existe registro de tu reserva. Serás redirigido a la página de reservas.
			</div>
		</DelayedRedirect>
		)

	if (!reservation || lineLoading || officeLoading) return <Spinner full />;
	if (error) return <ErrorMessage error={error} />

	return children({
		datetime,
		lineName: line.name || lineName,
		code: reservation.code,
		office: reservation.officeName,
		name: reservation.lineName,
		wait: line.wait,
		waiting: line.waiting,
		onClick: () => {} //cancelReservation
		//cancelLoading
	});
};

*/

export default RouteProvider(ReserveScreen);
